/// <reference types="@qstools/typescript" />